import React from 'react';

import { useQueryClient } from '@tanstack/react-query';
import { useAuth0 } from '@auth0/auth0-react';

export default function UserIsDisabledPage() {
  const queryClient = useQueryClient();
  const { logout } = useAuth0();

  return (
    <section className="bg-white dark:bg-gray-900">
      <div className="py-8 px-4 mx-auto max-w-screen-xl lg:py-16 lg:px-6">
        <div className="mx-auto max-w-screen-sm text-center">
          <h1 className="mb-4 text-7xl tracking-tight font-bold lg:text-9xl text-primary-600 dark:text-primary-500">
            403
          </h1>
          <p className="mb-4 text-3xl tracking-tight font-bold text-gray-900 md:text-4xl dark:text-white">
            Your account is disabled
          </p>
          <p className="mb-4 text-lg font-light text-gray-500 dark:text-gray-400">
            Sorry, your account is disabled. Please contact your administrator
          </p>
          <button
            className="inline-flex text-white bg-primary-600 hover:bg-primary-800 focus:ring-4 focus:outline-none focus:ring-primary-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:focus:ring-primary-900 my-4 cursor-pointer"
            onClick={() => {
              queryClient.clear();
              localStorage.clear();
              logout({
                logoutParams: {
                  returnTo: window.location.origin,
                },
              });
            }}
          >
            Sign out
          </button>
        </div>
      </div>
    </section>
  );
}
